module.exports = __webpack_public_path__ + "img/sr.658b680a.svg";